/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * DTO для обновления данных о пользователе участника в UI
 * @export
 * @interface ParticipantUserUpdateDto
 */
export interface ParticipantUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof ParticipantUserUpdateDto
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParticipantUserUpdateDto
     */
    isAdmin: boolean;
}

/**
 * Check if a given object implements the ParticipantUserUpdateDto interface.
 */
export function instanceOfParticipantUserUpdateDto(value: object): value is ParticipantUserUpdateDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    return true;
}

export function ParticipantUserUpdateDtoFromJSON(json: any): ParticipantUserUpdateDto {
    return ParticipantUserUpdateDtoFromJSONTyped(json, false);
}

export function ParticipantUserUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantUserUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'isAdmin': json['isAdmin'],
    };
}

export function ParticipantUserUpdateDtoToJSON(json: any): ParticipantUserUpdateDto {
    return ParticipantUserUpdateDtoToJSONTyped(json, false);
}

export function ParticipantUserUpdateDtoToJSONTyped(value?: ParticipantUserUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'isAdmin': value['isAdmin'],
    };
}

